import { AlphabetAurebeshIcon } from './AlphabetAurebeshIcon';

/**
 * author: Haley Halcyon
 * id 68AC0195-57C1-4759-8814-FA18DFE0351B
 * name alphabet-aurebesh
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alphabet-aurebesh.svg
 * tags
 * - Alpha / Numeric 
 */
export const WritingSystemAurebeshIcon = AlphabetAurebeshIcon;
export default WritingSystemAurebeshIcon